<template>
  <div class="optimize-script">
    <el-form
      :model="form"
      ref="formRef"
      :rules="rules"
      label-position="top"
      @submit.native.prevent
      class="settings-form ghost-button-styles"
    >
      <el-form-item label="原始脚本" prop="complete_script">
        <el-input v-model="form.complete_script" type="textarea" :rows="4" placeholder="请提供您需要调整的原始脚本内容..." />
      </el-form-item>

      <el-form-item label="调整要求" prop="optimization_instruction">
        <el-input style="margin-top: 10px" v-model="form.optimization_instruction" placeholder="例如：让结尾更有冲击力"></el-input>
      </el-form-item>

      <el-form-item label="视频时长" required>
        <el-radio-group v-model="form.target_duration" size="small" class="duration-group">
          <el-radio-button ghost :label="15">15秒</el-radio-button>
          <el-radio-button ghost :label="30">30秒</el-radio-button>
          <el-radio-button ghost :label="45">45秒</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-button type="primary" icon="el-icon-magic-stick" :loading="createLoading" class="action-button" @click="startAiCreate">
        AI即创作
      </el-button>
    </el-form>

    <!-- 生成后列表-->
    <ScriptDraftList :loading="createLoading" :scripts="scripts"></ScriptDraftList>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { scriptOptimizeCreate } from '@/api/material.model.js'
import ScriptDraftList from './script-draft-list.vue'

const formRef = ref(null)
// 表单数据
const form = ref({
  complete_script: '',
  optimization_instruction: '',
  target_duration: 30,
  shot_segment: -1
})
const createLoading = ref(false)
const scripts = ref([])
const rules = {
  complete_script: [
    { required: true, message: '请输入您的核心创意', trigger: 'blur' },
    { min: 5, max: 1000, message: '长度在5 到 1000 个字符', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        !value.trim() ? callback(new Error('请输入您的核心创意')) : callback()
      },
      trigger: 'blur'
    }
  ],
  optimization_instruction: [
    { required: true, message: '请输入自定义指令', trigger: 'blur' },
    { min: 2, max: 30, message: '长度在2 到 30 个字符', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (!value.trim()) {
          callback(new Error('请输入自定义指令'))
        }
        callback()
      },
      trigger: 'blur'
    }
  ]
}

function startAiCreate() {
  formRef.value.validate((valid) => {
    if (valid) {
      createLoading.value = true
      scriptOptimizeCreate({ function_type: 1, ai_params: { ...form.value } })
        .then((data) => {
          if (data) {
            scripts.value = data
          }
        })
        .finally(() => {
          createLoading.value = false
        })
    }
  })
}
</script>

<style scoped lang="scss">
.action-button {
  width: 100%;
  height: 44px;
  margin-top: 8px;
  font-weight: 600;
}
</style>
